import { render } from "./FeedItemCard.vue?vue&type=template&id=1d3d768f&scoped=true"
import script from "./FeedItemCard.vue?vue&type=script&lang=ts"
export * from "./FeedItemCard.vue?vue&type=script&lang=ts"

import "./FeedItemCard.vue?vue&type=style&index=0&id=1d3d768f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d3d768f"

export default script